import { render, staticRenderFns } from "./pcOrder.vue?vue&type=template&id=72070525&scoped=true&"
import script from "./pcOrder.vue?vue&type=script&lang=js&"
export * from "./pcOrder.vue?vue&type=script&lang=js&"
import style0 from "./pcOrder.vue?vue&type=style&index=0&id=72070525&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72070525",
  null
  
)

export default component.exports